import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsService from '../../Core/Services/SettingsService';

//Stripe
import { loadStripe } from '@stripe/stripe-js';

import {
  useStripe,
  useElements,
  Elements,
  PaymentElement,
} from '@stripe/react-stripe-js';

const stripePromise = loadStripe(SettingsService.getStripePublicKey());

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const { t } = useTranslation();

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + '/selfstorage?success=true',
      },
    });

    //This error almost never happens, but if it does, we want to show it to the user.
    if (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <>
      <form id="checkOutForm" onSubmit={handleSubmit}>
        <PaymentElement />

        {/* Show error message to your customers */}
        {errorMessage && (
          <div className="text-red-600 mb-2">{errorMessage}</div>
        )}
      </form>

      <div className="col-span-12 !border-t border-gray-300 p-4 flex justify-end">
        <div
          onClick={() =>
            document.getElementById('checkOutForm')?.requestSubmit()
          }
          className="py-2 px-4 cursor-pointer bg-primaryblue"
          style={{
            backgroundColor: 'oklch(70.5% 0.213 47.604) !important',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {t('confirm_button')}
        </div>
      </div>
    </>
  );
};

const StripePortal = ({ options }) => {
  if (!options?.clientSecret) return null;

  return (
    <Elements
      stripe={stripePromise}
      options={{ ...options, locale: SettingsService.getLanguage() }}
    >
      <CheckoutForm />
    </Elements>
  );
};

export default StripePortal;
